export const NOTIFICATION_LIST_FETCH = 'notification/NOTIFICATION_LIST_FETCH';
export const NOTIFICATION_LIST_SUCCESS = 'notification/NOTIFICATION_LIST_SUCCESS';
export const NOTIFICATION_READ_FETCH = 'notification/NOTIFICATION_READ_FETCH';
export const NOTIFICATION_READ_SUCCESS = 'notification/NOTIFICATION_READ_SUCCESS';
export const NOTIFICATION_READ_ERROR = 'notification/NOTIFICATION_READ_ERROR';
